/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@babel/runtime/regenerator/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/@babel/runtime/regenerator/index.js ***!
  \**********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(/*! regenerator-runtime */ "./node_modules/regenerator-runtime/runtime.js");


/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime.js":
/*!*****************************************************!*\
  !*** ./node_modules/regenerator-runtime/runtime.js ***!
  \*****************************************************/
/***/ ((module) => {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!****************************************!*\
  !*** ./src/assets/js/zapiet-widget.js ***!
  \****************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ZapietWidget = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ZapietWidget, _HTMLElement);

  var _super = _createSuper(ZapietWidget);

  function ZapietWidget() {
    var _this;

    _classCallCheck(this, ZapietWidget);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "setActiveTab", function () {
      if (_this.activeMode == 'Pickup') {
        _this.pickupButton.classList.add('zapiet-widget-header__tab--active');

        _this.deliveryButton.classList.remove('zapiet-widget-header__tab--active');

        _this.deliveryContainer.style.display = 'none';
        _this.pickupContainer.style.display = 'block';
        if (!_this.toggleSelectors) return;

        _this.toggleSelectors.forEach(function (toggle) {
          toggle.querySelectorAll('[data-shipping-toggler]')[0].classList.remove('active-toggler');
          toggle.querySelectorAll('[data-shipping-toggler]')[1].classList.add('active-toggler');
        });

        _this.clearLocalStorage('delivery');

        if (_this.pickupType == 'buttons') {
          _this.fetchPickupLocations();
        }
      } else {
        _this.pickupButton.classList.remove('zapiet-widget-header__tab--active');

        _this.deliveryButton.classList.add('zapiet-widget-header__tab--active');

        _this.deliveryContainer.style.display = 'block';
        _this.pickupContainer.style.display = 'none';
        if (!_this.toggleSelectors) return;

        _this.toggleSelectors.forEach(function (toggle) {
          toggle.querySelectorAll('[data-shipping-toggler]')[1].classList.remove('active-toggler');
          toggle.querySelectorAll('[data-shipping-toggler]')[0].classList.add('active-toggler');
        });

        _this.clearLocalStorage('pickup');
      }
    });

    _this.setActiveTab = _this.setActiveTab.bind(_assertThisInitialized(_this));
    _this.keyMode = 'Shipping Mode';
    _this.activeMode = localStorage.getItem(_this.keyMode) ? localStorage.getItem(_this.keyMode) : 'Delivery';
    _this.deliveryButton = _this.querySelectorAll('.zapiet-widget-header__tab')[0];
    _this.pickupButton = _this.querySelectorAll('.zapiet-widget-header__tab')[1];
    _this.deliveryContainer = _this.querySelector('.zapiet-widget__delivery');
    _this.pickupContainer = _this.querySelector('.zapiet-widegt__pickup');
    _this.searchInput = _this.querySelector('.zapiet-widget-header__delivery-search input');
    _this.selectedAddress = {}; // Initialize selected address state

    _this.googleMapsApi = _this.getAttribute('data-googleapi');
    _this.changeLocation = _this.querySelector('.change-results-btn button');
    _this.resultsText = _this.querySelector('.results-text span');
    _this.shippingHolder = _this.querySelector('.zapiet-widget-header__delivery-search-results');
    _this.permDomain = _this.getAttribute('data-permdomain');
    _this.searchButton = _this.querySelector('.zapiet-widget-header__delivery-search button');
    _this.saveButton = _this.querySelector('.zapiet-widget__save');
    _this.pickupCta = _this.querySelector('.zapiet-widget__pickup-cta');
    _this.pickupType = _this.dataset.pickuptype;
    _this.pickupLocationWrapper = _this.querySelector('.pickup-locations-wrapper');
    _this.menuClose = document.querySelector('.menu__close_icon');
    _this.modal = document.querySelector('zapiet-modal'); // pickup information

    _this.locationHeader = _this.querySelector('.zapiet__pickup-results__location-name');
    _this.globalLocationHeader = document.querySelectorAll('.shop-selector__location');
    _this.locationState = _this.querySelector('.zapiet__pickup-results__location-state');
    _this.locationAddress = _this.querySelector('.zapiet-pickup-results__location-address');
    _this.locationTime = _this.querySelector('.zapiet-pickup-results__location-time');
    _this.resultsContainer = _this.querySelector('.zapiet-widget__pickup-results');
    _this.dropdown = _this.querySelector('.zapiet-widget__pickup-main-wrapper__dropdown');
    _this.searchInputPickup = _this.querySelector('.pickup-search');
    _this.infoSpan = _this.querySelector('.zapiet-widget__info');
    _this.arrowDown = _this.querySelector('.zapiet-widget__pickup-cta'); // toggle shipping in the header

    _this.toggleSelectors = document.querySelectorAll('.shipping-togglers');
    _this.checkoutButton = document.querySelector('[name="checkout"]');
    return _this;
  }

  _createClass(ZapietWidget, [{
    key: "clearLocalStorage",
    value: function clearLocalStorage(mode) {
      console.log('cleared local storage');

      if (mode == 'delivery') {
        localStorage.removeItem('Delivery-Timezone');
        localStorage.removeItem('Delivery-Object');
        localStorage.removeItem('Checkout-Method');
        localStorage.removeItem('Delivery-Location-Id');
        localStorage.removeItem('Delivery-Date');
        localStorage.removeItem('Delivery-Time');
        localStorage.removeItem('Delivery-Slot-Id');
        localStorage.removeItem('Full-Address'); // Added line to save fullAddress
      } else {
        localStorage.removeItem('Pickup-Location-Id');
        localStorage.removeItem('Pickup-Location-Company');
        localStorage.removeItem('Pickup-Location-Address-Line-1');
        localStorage.removeItem('Pickup-Location-City');
        localStorage.removeItem('Pickup-Location-Region');
        localStorage.removeItem('Pickup-Location-Postal-Code');
        localStorage.removeItem('Pickup-Location-Country');
      }
    }
  }, {
    key: "pullAndUpdateCartAttributes",
    value: function () {
      var _pullAndUpdateCartAttributes = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, cartData, checkoutMethod, _i, _arr, attribute, _i2, _arr2, _attribute;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('pulling cart attributes');
                _context.prev = 1;
                _context.next = 4;
                return fetch('/cart.js');

              case 4:
                response = _context.sent;
                _context.next = 7;
                return response.json();

              case 7:
                cartData = _context.sent;
                checkoutMethod = cartData.attributes["Checkout-Method"];

                if (checkoutMethod) {
                  localStorage.setItem("Checkout-Method", checkoutMethod);
                  localStorage.setItem("Shipping Mode", checkoutMethod.charAt(0).toUpperCase() + checkoutMethod.slice(1));
                } // Update other attributes based on checkout method


                if (checkoutMethod === "pickup") {
                  for (_i = 0, _arr = ["Pickup-Location-Id", "Pickup-Location-Company", "Pickup-Location-Address-Line-1", "Pickup-Location-City", "Pickup-Location-Region", "Pickup-Location-Postal-Code", "Pickup-Location-Country"]; _i < _arr.length; _i++) {
                    attribute = _arr[_i];

                    if (cartData.attributes[attribute]) {
                      localStorage.setItem(attribute, cartData.attributes[attribute]);
                    }
                  }
                } else if (checkoutMethod === "delivery") {
                  for (_i2 = 0, _arr2 = ["Delivery-Timezone", "Delivery-Object", "Delivery-Location-Id", "Delivery-Date", "Delivery-Time", "Delivery-Slot-Id", "Full-Address"]; _i2 < _arr2.length; _i2++) {
                    _attribute = _arr2[_i2];

                    if (cartData.attributes[_attribute]) {
                      localStorage.setItem(_attribute, cartData.attributes[_attribute]);
                    }
                  }
                }

                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](1);
                console.log("Error fetching cart attributes:", _context.t0);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 13]]);
      }));

      function pullAndUpdateCartAttributes() {
        return _pullAndUpdateCartAttributes.apply(this, arguments);
      }

      return pullAndUpdateCartAttributes;
    }()
  }, {
    key: "makeZapietPostRequest",
    value: function makeZapietPostRequest() {
      var _this2 = this;

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "geoSearchQuery": this.selectedAddress.fullAddress,
        "shoppingCart": [{
          "variant_id": 41199818965191,
          "product_id": 7076691574983,
          "quantity": 2
        }]
      });
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
      fetch("https://api-us.zapiet.com/v1.0/delivery/locations?shop=".concat(this.permDomain), requestOptions).then(function (response) {
        return response.json();
      }).then(function (result) {
        if (result.error && result.error.code === "NO_LOCATIONS_FOUND") {
          var emptyMessage = _this2.getAttribute('data-empty') || "No results found";
          _this2.resultsText.textContent = emptyMessage;

          _this2.shippingHolder.classList.remove('hidden');

          _this2.shippingHolder.classList.add('flex');

          _this2.saveButton.classList.add('hidden');

          _this2.saveButton.classList.remove('flex');

          _this2.clearLocalStorage('delivery');
        } else {
          // Save required data to localStorage
          localStorage.setItem('Delivery-Timezone', result.timezone);
          localStorage.setItem('Delivery-Object', JSON.stringify(result.delivery));
          localStorage.setItem('Checkout-Method', 'delivery');
          localStorage.setItem('Delivery-Location-Id', result.id);
          document.querySelector('zapiet-modal').hideBlock();

          _this2.shippingHolder.classList.remove('hidden');

          _this2.shippingHolder.classList.add('flex');

          var today = new Date();
          var formattedDate = "".concat(today.getFullYear(), "-").concat(String(today.getMonth() + 1).padStart(2, '0'), "-").concat(String(today.getDate()).padStart(2, '0'));
          localStorage.setItem('Delivery-Date', formattedDate);
          var currentDate = new Date();
          var oneHourFromNow = new Date(currentDate.getTime() + 60 * 60 * 1000);
          var twoHoursFromNow = new Date(today.getTime() + 2 * 60 * 60 * 1000);
          var start24Hour = "".concat(String(oneHourFromNow.getHours()).padStart(2, '0'), ":").concat(String(oneHourFromNow.getMinutes()).padStart(2, '0'));
          var end24Hour = "".concat(String(twoHoursFromNow.getHours()).padStart(2, '0'), ":").concat(String(twoHoursFromNow.getMinutes()).padStart(2, '0'));
          var start12Hour = oneHourFromNow.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
          });
          var end12Hour = twoHoursFromNow.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
          });
          var formattedDeliveryTime = "".concat(start24Hour, " - ").concat(end24Hour, " / ").concat(start12Hour, " - ").concat(end12Hour);
          localStorage.setItem('Delivery-Time', formattedDeliveryTime);
          localStorage.setItem('Delivery-Slot-Id', result.delivery.monday.slots.slots[0].id || '');
          localStorage.setItem('Full-Address', _this2.selectedAddress.fullAddress); // Added line to save fullAddress

          _this2.resultsText.textContent = _this2.selectedAddress.fullAddress;
          var result_address = _this2.selectedAddress.fullAddress;

          _this2.globalLocationHeader.forEach(function (location) {
            location.textContent = result_address;
            console.log(result_address, 'result_address');
          });

          _this2.shippingHolder.classList.remove('hidden');

          _this2.shippingHolder.classList.add('flex');

          _this2.saveButton.classList.remove('hidden');

          _this2.saveButton.classList.add('flex');

          _this2.updateCartNotes();
        }
      })["catch"](function (error) {
        return console.log('error', error);
      });
    }
  }, {
    key: "onSearchInput",
    value: function onSearchInput(autocomplete) {
      var _this3 = this;

      autocomplete.addListener('place_changed', function () {
        var place = autocomplete.getPlace();

        if (!place.geometry) {
          return;
        } // Extract ZIP code and full address


        var addressComponents = place.address_components;
        var zipObj = addressComponents.find(function (component) {
          return component.types.includes('postal_code');
        });
        var zipCode = zipObj ? zipObj.long_name : null;
        var fullAddress = place.formatted_address; // Update selectedAddress

        _this3.selectedAddress = {
          zipCode: zipCode,
          fullAddress: fullAddress
        };
        _this3.searchInput.value = fullAddress; // Set input value
      });
    }
  }, {
    key: "initGoogleMaps",
    value: function initGoogleMaps() {
      var _this4 = this;

      // Check if the script is already present in the document
      var existingScript = document.querySelector('script[data-identifier="google-maps-api"]');

      if (existingScript) {
        console.log("Google Maps API script already loaded.");
        return;
      } // Create a new script element


      var script = document.createElement('script');
      script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(this.googleMapsApi, "&libraries=places&language=en");
      script.setAttribute('data-identifier', 'google-maps-api'); // Add a unique identifier
      // Append the script to the document head

      document.head.appendChild(script); // Load event listener

      script.onload = function () {
        var autocomplete = new google.maps.places.Autocomplete(_this4.searchInput);

        _this4.onSearchInput(autocomplete);
      };
    }
  }, {
    key: "handleCheckout",
    value: function handleCheckout() {
      this.checkoutButton.addEventListener('click', function (e) {
        e.preventDefault();
      });
    }
  }, {
    key: "initWidget",
    value: function initWidget() {
      var _this5 = this;

      var storedAddress = localStorage.getItem('Full-Address');

      if (storedAddress) {
        this.selectedAddress.fullAddress = storedAddress;
        this.searchInput.value = storedAddress; // Pre-fill input field

        this.resultsText.textContent = storedAddress; // Pre-fill results text

        var result_address = this.selectedAddress.fullAddress;
        this.globalLocationHeader.forEach(function (location) {
          location.textContent = result_address;
          console.log(result_address, 'result_address');
        });
        console.log(storedAddress, 'storedAddress');

        if (!storedAddress) {
          this.shippingHolder.classList.add('hidden');
          this.shippingHolder.classList.remove('flex');
          this.saveButton.classList.add('hidden');
          this.saveButton.classList.remove('flex');
        } else {
          this.shippingHolder.classList.remove('hidden');
          this.shippingHolder.classList.add('flex');
          this.saveButton.classList.remove('hidden');
          this.saveButton.classList.add('flex');
        }
      }

      if (this.pickupButton && this.deliveryButton) {
        this.setActiveTab();

        this.pickupButton.onclick = function () {
          _this5.setActiveMode('Pickup');
        };

        this.deliveryButton.onclick = function () {
          _this5.setActiveMode('Delivery');
        };
      }

      this.initGoogleMaps();

      this.changeLocation.onclick = function () {
        _this5.searchInput.focus();
      };

      var searchButton = this.searchButton;

      if (searchButton) {
        searchButton.addEventListener('click', this.makeZapietPostRequest.bind(this));
      }

      this.saveButton.addEventListener('click', function () {
        _this5.modal.closeModal();
      });
      var updateCartNotes = this.updateCartNotes.bind(this);
      setTimeout(function () {
        if (window.ZapietEvent) {
          window.ZapietEvent.listen('delivery.datepicker.opened', function () {
            var _this6 = this;

            var geoSearchField = document.querySelector('#deliveryGeoSearchField');

            if (geoSearchField && geoSearchField.value) {
              console.log('test found');
              localStorage.setItem('Full-Address', geoSearchField.value);
              document.querySelector('zapiet-widget').initWidget();
              console.log('localstorage info', localStorage.getItem('Full-Address'));
              this.activeMode = 'Delivery';
              this.clearLocalStorage('pickup');
              document.querySelector('.cart__atributes-info__title').textContent = 'Local Delivery';
              updateCartNotes(); // Assuming `updateCartNotes` is a global function

              this.globalLocationHeader.forEach(function (location) {
                location.textContent = geoSearchField.value;
                console.log(geoSearchField.value, 'result_address 2');
              });
              setTimeout(function () {
                _this6.setActiveTab();
              }, 2000);
            }
          }.bind(_this5));
          window.ZapietEvent.listen('pickup.datepicker.opened', function () {
            var _this7 = this;

            console.log('test foun 2d');
            localStorage.setItem('Pickup-Location-Company', document.querySelector('.location.active span.name').textContent);
            localStorage.setItem('Pickup-Location-Id', document.querySelector('.location.active').id.replace('location_', ''));
            this.activeMode = 'Pickup';
            this.clearLocalStorage('delivery');
            document.querySelector('.cart__atributes-info__title').textContent = 'Pickup';
            updateCartNotes(); // Assuming `updateCartNotes` is a global function

            this.globalLocationHeader.forEach(function (location) {
              location.textContent = document.querySelector('.location.active span.name').textContent;
              console.log(document.querySelector('.location.active span.name').textContent, 'result_address 2');
            });
            setTimeout(function () {
              _this7.setActiveTab();

              _this7.fetchPickupLocations(true);

              setTimeout(function () {
                _this7.populatePreviousSelection();
              }, 600);
            }, 2000);
          }.bind(_this5));
        }
      }, 2500);
    }
  }, {
    key: "setActiveMode",
    value: function setActiveMode(mode) {
      localStorage.setItem(this.keyMode, mode);
      this.activeMode = mode;
      this.setActiveTab();
    } // pickup logic

  }, {
    key: "populatePreviousSelection",
    value: function populatePreviousSelection() {
      var _this8 = this;

      // this.pullAndUpdateCartAttributes();
      if (this.activeMode == 'Pickup') {
        this.fetchPickupLocations(true);
      }

      setTimeout(function () {
        var storedLocation = localStorage.getItem('Pickup-Location');

        if (storedLocation && _this8.activeMode == 'Pickup') {
          var previousLocation = JSON.parse(storedLocation);

          _this8.selectPickupLocation(previousLocation);
        }
      }, 800);
    } // Method to make POST request for Pickup locations

  }, {
    key: "fetchPickupLocations",
    value: function fetchPickupLocations(show_id) {
      var _this9 = this;

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json"); // Adding random info here so zapiet will give a response

      var raw = JSON.stringify({
        "shoppingCart": [{
          "variant_id": 41199818965191,
          "product_id": 7076691574983,
          "quantity": 2
        }]
      });
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
      fetch("https://api-us.zapiet.com/v1.0/pickup/locations?shop=".concat(this.permDomain), requestOptions).then(function (response) {
        return response.json();
      }).then(function (result) {
        var locations = result.locations;

        if (show_id) {
          var id = localStorage.getItem('Pickup-Location-Id');
          var intId = parseInt(id);
          locations.forEach(function (location) {
            if (location.id === intId) {
              localStorage.setItem('Pickup-Location', JSON.stringify(location));
              return;
            }
          });
          return;
        } else {
          // Parse and create dropdown
          _this9.createPickupDropdown(result);
        }
      })["catch"](function (error) {
        console.log('Error:', error);
      });
    } // Method to create dropdown and populate it with locations

  }, {
    key: "createPickupDropdown",
    value: function createPickupDropdown(data) {
      var _this10 = this;

      var dropdown = this.dropdown;
      var pickupLocationWrapper = this.pickupLocationWrapper;
      dropdown.innerHTML = ''; // Clear existing items

      var currentDate = new Date();
      var weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      var currentDay = weekdays[currentDate.getDay()];
      data.locations.forEach(function (location) {
        // Calculate current time and compare with opening and closing times
        var openingTime = location.opening_hours[currentDay].opens;
        var closingTime = location.opening_hours[currentDay].closes;

        var _openingTime$split$ma = openingTime.split(':').map(Number),
            _openingTime$split$ma2 = _slicedToArray(_openingTime$split$ma, 2),
            openingHours = _openingTime$split$ma2[0],
            openingMinutes = _openingTime$split$ma2[1];

        var _closingTime$split$ma = closingTime.split(':').map(Number),
            _closingTime$split$ma2 = _slicedToArray(_closingTime$split$ma, 2),
            closingHours = _closingTime$split$ma2[0],
            closingMinutes = _closingTime$split$ma2[1];

        var currentHour = currentDate.getHours();
        var currentMinutes = currentDate.getMinutes();
        var currentTotalMinutes = currentHour * 60 + currentMinutes;
        var openingTotalMinutes = openingHours * 60 + openingMinutes;
        var closingTotalMinutes = closingHours * 60 + closingMinutes;
        var activeLocationId = localStorage.getItem('Pickup-Location-Id');
        var isOpen = currentTotalMinutes >= openingTotalMinutes && currentTotalMinutes <= closingTotalMinutes; // Create new dropdown item

        var div = document.createElement('div');
        div.className = 'dropdown-item';
        div.textContent = location.company_name;
        var span = document.createElement('span');
        span.textContent = isOpen ? 'Open' : 'Closed';
        span.className = isOpen ? 'open' : 'closed';
        div.classList = isOpen ? div.classList + ' dropdown-item--open' : div.classList + ' dropdown-item--closed';
        div.appendChild(span);
        div.dataset.id = location.id;
        div.dataset.search = location.company_name.toLowerCase();

        if (location.id.toString() === activeLocationId) {
          div.classList.add('dropdown-item--active');
        }

        _this10.searchInputPickup.addEventListener('input', function () {
          var query = _this10.searchInputPickup.value.toLowerCase();

          var items = _this10.dropdown.querySelectorAll('.dropdown-item');

          items.forEach(function (item) {
            var name = item.dataset.search;

            if (name.includes(query)) {
              item.style.display = 'flex';
            } else {
              item.style.display = 'none';
            }
          });
        });

        _this10.searchInputPickup.addEventListener('focus', function () {
          _this10.infoSpan.textContent = _this10.infoSpan.dataset.pickupOpened;

          _this10.dropdown.classList.add('active-widget'); // Assuming this class makes the dropdown visible

        });

        _this10.arrowDown.addEventListener('click', function () {
          _this10.searchInputPickup.focus();
        });

        div.addEventListener('click', function () {
          // First, remove active class from all items
          document.querySelectorAll('.dropdown-item').forEach(function (item) {
            item.classList.remove('dropdown-item--active');
          }); // Then, add active class to the clicked item

          div.classList.add('dropdown-item--active'); // Your existing logic to handle selection

          _this10.selectPickupLocation(location);

          if (_this10.pickupType != 'buttons') {
            _this10.dropdown.classList.remove('active-widget');
          }
        });
        dropdown.appendChild(div); // pickupLocationWrapper.appendChild(div);
      });
    }
  }, {
    key: "selectPickupLocation",
    value: function selectPickupLocation(location, redirectUrl) {
      // Update UI elements with the selected location's details
      this.locationHeader.textContent = location.company_name;
      var result_address = location.company_name;
      this.globalLocationHeader.forEach(function (location) {
        location.textContent = result_address;
        console.log(result_address, 'result_address');
      });
      this.locationAddress.textContent = "".concat(location.address_line_1, ", ").concat(location.city).concat(location.region ? ', ' + location.region : ''); // Determine the current day of the week

      var weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      var currentDate = new Date();
      var currentDay = weekdays[currentDate.getDay()]; // Get opening and closing times for the current day

      var openingTime = location.opening_hours[currentDay].opens;
      var closingTime = location.opening_hours[currentDay].closes;
      this.locationTime.textContent = "Open from ".concat(openingTime, " to ").concat(closingTime, " Daily");

      var _openingTime$split$ma3 = openingTime.split(':').map(Number),
          _openingTime$split$ma4 = _slicedToArray(_openingTime$split$ma3, 2),
          openingHours = _openingTime$split$ma4[0],
          openingMinutes = _openingTime$split$ma4[1];

      var _closingTime$split$ma3 = closingTime.split(':').map(Number),
          _closingTime$split$ma4 = _slicedToArray(_closingTime$split$ma3, 2),
          closingHours = _closingTime$split$ma4[0],
          closingMinutes = _closingTime$split$ma4[1];

      var currentHour = currentDate.getHours();
      var currentMinutes = currentDate.getMinutes();
      var currentTotalMinutes = currentHour * 60 + currentMinutes;
      var openingTotalMinutes = openingHours * 60 + openingMinutes;
      var closingTotalMinutes = closingHours * 60 + closingMinutes;

      if (currentTotalMinutes >= openingTotalMinutes && currentTotalMinutes <= closingTotalMinutes) {
        this.locationState.textContent = 'Open now';
      } else {
        this.locationState.textContent = 'Closed';
        this.locationState.classList.add('closed');
      } // Remove hidden class to display the results container


      this.resultsContainer.classList.remove('hidden'); // Save relevant information to local storage

      localStorage.setItem('Checkout-Method', 'pickup');
      localStorage.setItem('Pickup-Location-Id', location.id);
      document.querySelector('zapiet-modal').hideBlock();
      localStorage.setItem('Pickup-Location-Company', location.company_name);
      localStorage.setItem('Pickup-Location-Address-Line-1', location.address_line_1);
      localStorage.setItem('Pickup-Location-City', location.city);
      localStorage.setItem('Pickup-Location-Region', location.region);
      localStorage.setItem('Pickup-Location-Postal-Code', location.postal_code);
      localStorage.setItem('Pickup-Location-Country', location.country);
      var today = new Date();
      var formattedDate = "".concat(today.getFullYear(), "-").concat(String(today.getMonth() + 1).padStart(2, '0'), "-").concat(String(today.getDate()).padStart(2, '0'));
      localStorage.setItem('Pickup-Date', formattedDate);
      var oneHourFromNow = new Date(currentDate.getTime() + 60 * 60 * 1000);
      var time24Hour = "".concat(String(oneHourFromNow.getHours()).padStart(2, '0'), ":").concat(String(oneHourFromNow.getMinutes()).padStart(2, '0'));
      var time12Hour = oneHourFromNow.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      });
      var formattedTime = "".concat(time24Hour, " / ").concat(time12Hour);
      localStorage.setItem('Pickup-Time', formattedTime);
      localStorage.setItem('Pickup-Location', JSON.stringify(location));
      this.saveButton.classList.remove('hidden');

      if (redirectUrl) {
        window.location.href = redirectUrl;
      }

      this.saveButton.classList.add('flex');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this11 = this;

      this.initWidget();
      this.populatePreviousSelection();

      if (this.pickupType == 'buttons') {
        this.fetchPickupLocations();
      }

      var pickupCta = this.pickupCta;

      if (pickupCta) {
        pickupCta.addEventListener('click', function () {
          if (_this11.dropdown.classList.contains('active-widget')) {
            _this11.dropdown.classList.remove('active-widget');
          } else {
            _this11.dropdown.classList.add('active-widget');

            _this11.searchInputPickup.focus();

            _this11.infoSpan.textContent = _this11.infoSpan.dataset.pickupOpened;

            _this11.fetchPickupLocations();
          }
        });
      }

      if (this.menuClose) {
        this.menuClose.addEventListener('click', function () {
          _this11.modal.closeModal();
        });
      }
    }
  }, {
    key: "reloadCart",
    value: function reloadCart() {
      var _this13 = this;

      var activeMode = this.activeMode;
      setTimeout(function () {
        fetch(window.location.href).then(function (response) {
          return response.text();
        }).then(function (html) {
          var _this12 = this;

          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          if (document.querySelector('.cart-content')) {
            document.querySelector('.cart-content').innerHTML = doc.querySelector('.cart-content').innerHTML;
          }

          Zapiet.start(ZapietWidgetConfig);
          var intervalId = setInterval(function () {
            var element = document.querySelector("#storePickupApp");
            window.ZapietEvent.listen('selected_method', function (checkout_method) {
              switch (checkout_method) {
                case "pickup":
                  document.querySelector('zapiet-widget').clearLocalStorage('delivery');
                  document.querySelector('zapiet-widget').activeMode = 'Pickup';
                  break;

                case "delivery":
                  document.querySelector('zapiet-widget').clearLocalStorage('pickup');
                  document.querySelector('zapiet-widget').activeMode = 'Delivery';
                  break;
              }
            }.bind(_this12));

            if (element) {
              clearInterval(intervalId);
              console.log('interval cleared');

              if (activeMode == 'Delivery') {
                document.querySelector('zapiet-widget').activeMode = 'Delivery';

                if (element.querySelectorAll('.checkoutMethod')[0]) {
                  element.querySelectorAll('.checkoutMethod')[0].click();
                }

                setTimeout(function () {
                  if (element.querySelector('.Zapiet-InputWithPrefix__Input')) {
                    element.querySelector('.Zapiet-InputWithPrefix__Input').value = localStorage.getItem('Full-Address');
                  }

                  var inputElement = document.querySelector('.Zapiet-InputWithPrefix__Input'); // Create a new 'change' event

                  var event = new Event('input', {
                    'bubbles': true,
                    'cancelable': true
                  }); // Dispatch the event on the input element

                  inputElement.dispatchEvent(event);
                  setTimeout(function () {
                    if (document.querySelectorAll('.Zapiet-Autocomplete__Item')[0]) {
                      document.querySelectorAll('.Zapiet-Autocomplete__Item')[0].click();
                    }
                  }, 800);
                }, 500);
              } else {
                if (element.querySelectorAll('.checkoutMethod')[1]) {
                  element.querySelectorAll('.checkoutMethod')[1].click();
                }

                document.querySelector('zapiet-widget').activeMode = 'Pickup';
                setTimeout(function () {
                  var _document$querySelect;

                  var storedLocation = localStorage.getItem('Pickup-Location');
                  storedLocation = JSON.parse(storedLocation);
                  var locationId = storedLocation.id;
                  (_document$querySelect = document.querySelector("#location_".concat(locationId))) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.click();
                }, 1400);
              }
            }
          }, 1000); // Checks every 1000 milliseconds (1 second)
        })["catch"](function (err) {
          console.warn('Something went wrong.', err);
        });
      }, 800); // zapiet doesn't have an event listener on their input changes, so I have to update it manually

      this.updateCartNotes();
      setInterval(function () {
        _this13.pullAndUpdateCartAttributes();
      }, 5000);
    }
  }, {
    key: "updateCartNotes",
    value: function updateCartNotes() {
      var checkoutMethod = localStorage.getItem('Checkout-Method'); // Initialize cart attributes object

      var cartAttributes = {};

      if (checkoutMethod === 'pickup') {
        // Populate cart attributes for pickup
        cartAttributes = {
          "Pickup-Location": localStorage.getItem('Pickup-Location-Id'),
          "Pickup-Date": localStorage.getItem('Pickup-Date'),
          "Pickup-Time": localStorage.getItem('Pickup-Time'),
          "Checkout-Method": localStorage.getItem('Checkout-Method'),
          "Pickup-Location-Company": localStorage.getItem('Pickup-Location-Company'),
          "Pickup-Location-Id": localStorage.getItem('Pickup-Location-Id'),
          "Pickup-Location-Address-Line-1": localStorage.getItem('Pickup-Location-Address-Line-1'),
          "Pickup-Location-City": localStorage.getItem('Pickup-Location-City'),
          "Pickup-Location-Region": localStorage.getItem('Pickup-Location-Region'),
          "Pickup-Location-Postal-Code": localStorage.getItem('Pickup-Location-Postal-Code'),
          "Pickup-Location-Country": localStorage.getItem('Pickup-Location-Country')
        };
      } else if (checkoutMethod === 'delivery') {
        // Populate cart attributes for delivery
        cartAttributes = {
          "Checkout-Method": localStorage.getItem('Checkout-Method'),
          "Delivery-Location-Id": localStorage.getItem('Delivery-Location-Id'),
          "Delivery-Date": localStorage.getItem('Delivery-Date'),
          "Delivery-Time": localStorage.getItem('Delivery-Time'),
          "Delivery-Full-Address": localStorage.getItem('Full-Address')
        };
      } // Update cart attributes using fetch API


      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: cartAttributes
        })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        console.log("Cart attributes updated successfully.", data);
        document.querySelectorAll('.item_count').forEach(function (count) {
          count.textContent = data.item_count;

          if (count.textContent == '0') {
            count.classList.add('hidden');
          } else {
            count.classList.remove('hidden');
          }
        });
      })["catch"](function (error) {
        console.log("Error updating cart attributes:", error);
      });
      setTimeout(function () {
        fetch(window.location.href).then(function (response) {
          return response.text();
        }).then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          document.querySelector('.cart__atributes-info').innerHTML = doc.querySelector('.cart__atributes-info').innerHTML;
        })["catch"](function (err) {
          console.warn('Something went wrong.', err);
        });
      }, 2000);
    }
  }]);

  return ZapietWidget;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('zapiet-widget', ZapietWidget); // prefilling zapiet config with data because it's unavailable once product is added to cart first time

document.addEventListener('DOMContentLoaded', function () {
  if (!ZapietWidgetConfig.cached_config) {
    ZapietWidgetConfig = ZapietWidgetConfig = {
      "cached_config": {
        "enable_app": true,
        "enable_geo_search_for_pickups": false,
        "pickup_region_filter_enabled": false,
        "currency": "AUD",
        "weight_format": "kg",
        "pickup.enable_map": false,
        "delivery_validation_method": "within_max_radius",
        "base_country_name": "Kenya",
        "base_country_code": "KE",
        "method_display_style": "default",
        "date_format": "l, F j, Y",
        "time_format": "h:i A",
        "pickup_address_format": "<span class=\"name\"><strong>{{company_name}}</strong></span><span class=\"address\">{{address_line_1}}<br>{{city}}, {{postal_code}}</span><span class=\"distance\">{{distance}}</span>{{more_information}}",
        "rates_enabled": true,
        "distance_format": "km",
        "enable_delivery_address_autocompletion": true,
        "enable_pickup_address_autocompletion": false,
        "pickup_date_picker_enabled": true,
        "pickup_time_picker_enabled": true,
        "delivery_note_enabled": false,
        "delivery_note_required": false,
        "delivery_date_picker_enabled": true,
        "delivery_time_picker_enabled": true,
        "shipping.date_picker_enabled": false,
        "delivery_validate_cart": false,
        "pickup_validate_cart": false,
        "gmak": "QUl6YVN5Q0c3b1FwT21UM2cxRVJ3VGZNdEptSFFJaDVWRVRpamxB",
        "enable_checkout_locale": true,
        "enable_checkout_url": true,
        "disable_widget_for_digital_items": false,
        "disable_widget_for_product_handles": "gift-card",
        "delivery_validator": {
          "enabled": false,
          "show_on_page_load": false,
          "sticky": false
        },
        "checkout": {
          "delivery": {
            "discount_code": null,
            "prepopulate_shipping_address": true
          },
          "pickup": {
            "discount_code": "",
            "prepopulate_shipping_address": true,
            "customer_phone_required": false,
            "preselect_first_location": true
          },
          "shipping": {
            "discount_code": null
          }
        },
        "day_name_attribute_enabled": false,
        "methods": {
          "delivery": {
            "active": true,
            "enabled": true,
            "name": "Delivery",
            "sort": 2,
            "status": {
              "condition": "weight",
              "operator": "morethan",
              "value": 0,
              "enabled": true,
              "product_conditions": {
                "enabled": false,
                "value": "Pickup Only,Shipping Only",
                "enable": false,
                "property": "tags",
                "hide_button": false
              }
            },
            "button": {
              "type": "default",
              "default": "",
              "hover": "",
              "active": ""
            },
            "error": null,
            "image": "//s3-us-west-2.amazonaws.com/zapiet/uploads/default/delivery.svg"
          },
          "pickup": {
            "active": false,
            "enabled": true,
            "name": "Pickup",
            "sort": 3,
            "status": {
              "condition": "price",
              "operator": "morethan",
              "value": 0,
              "enabled": true,
              "product_conditions": {
                "enabled": false,
                "value": "Delivery Only,Shipping Only",
                "enable": false,
                "property": "tags",
                "hide_button": false
              }
            },
            "button": {
              "type": "default",
              "default": "",
              "hover": "",
              "active": ""
            },
            "error": null,
            "image": "//s3-us-west-2.amazonaws.com/zapiet/uploads/default/pickup.svg"
          }
        },
        "translations": {
          "methods": {
            "shipping": "Shipping",
            "pickup": "Pickups",
            "delivery": "Delivery"
          },
          "calendar": {
            "january": "January",
            "february": "February",
            "march": "March",
            "april": "April",
            "may": "May",
            "june": "June",
            "july": "July",
            "august": "August",
            "september": "September",
            "october": "October",
            "november": "November",
            "december": "December",
            "sunday": "Sun",
            "monday": "Mon",
            "tuesday": "Tue",
            "wednesday": "Wed",
            "thursday": "Thu",
            "friday": "Fri",
            "saturday": "Sat",
            "today": "",
            "close": "",
            "labelMonthNext": "Next month",
            "labelMonthPrev": "Previous month",
            "labelMonthSelect": "Select a month",
            "labelYearSelect": "Select a year",
            "and": "and",
            "between": "between"
          },
          "pickup": {
            "heading": "Store Pickup",
            "note": "",
            "location_placeholder": "Enter your postal code ...",
            "filter_by_region_placeholder": "Filter by state/province",
            "location_label": "Choose a location.",
            "datepicker_label": "Choose a date and time.",
            "date_time_output": "{{DATE}} at {{TIME}}",
            "datepicker_placeholder": "Choose a date and time.",
            "locations_found": "Please select a pickup location:",
            "no_locations_found": "Sorry, pickup is not available for your selected items.",
            "no_locations_region": "Sorry, pickup is not available in your region.",
            "no_date_time_selected": "Please select a date & time.",
            "checkout_button": "Checkout",
            "could_not_find_location": "Sorry, we could not find your location.",
            "checkout_error": "Please select a date and time for pickup.",
            "location_error": "Please select a pickup location.",
            "more_information": "More information",
            "opening_hours": "Opening hours",
            "dates_not_available": "Sorry, your selected items are not currently available for pickup.",
            "min_order_total": "Minimum order value for pickup is $0.00",
            "min_order_weight": "Minimum order weight for pickup is {{ weight }}",
            "max_order_total": "Maximum order value for pickup is $0.00",
            "max_order_weight": "Maximum order weight for pickup is {{ weight }}",
            "cart_eligibility_error": "Sorry, pickup is not available for your selected items."
          },
          "delivery": {
            "heading": "Local Delivery",
            "note": "Enter your postal code to check if you are eligible for local delivery:",
            "location_placeholder": "Enter your postal code ...",
            "datepicker_label": "Choose a date and time.",
            "datepicker_placeholder": "Choose a date and time.",
            "date_time_output": "{{DATE}} between {{SLOT_START_TIME}} and {{SLOT_END_TIME}}",
            "available": "Great! You are eligible for delivery.",
            "not_available": "Sorry, delivery is not available in your area.",
            "no_date_time_selected": "Please select a date & time for delivery.",
            "checkout_button": "Checkout",
            "could_not_find_location": "Sorry, we could not find your location.",
            "checkout_error": "Please enter a valid zipcode and select your preferred date and time for delivery.",
            "cart_eligibility_error": "Sorry, delivery is not available for your selected items.",
            "dates_not_available": "Sorry, your selected items are not currently available for delivery.",
            "min_order_total": "Minimum order value for delivery is {{ price }}",
            "min_order_weight": "Minimum order weight for delivery is 0.00kg",
            "max_order_total": "Maximum order value for delivery is {{ price }}",
            "max_order_weight": "Maximum order weight for delivery is 0.00kg",
            "delivery_validator_prelude": "Do we deliver?",
            "delivery_validator_placeholder": "Enter your postal code ...",
            "delivery_validator_button_label": "Go",
            "delivery_validator_eligible_heading": "Great, we deliver to your area!",
            "delivery_validator_eligible_content": "To start shopping just click the button below",
            "delivery_validator_eligible_button_label": "Continue shopping",
            "delivery_validator_not_eligible_heading": "Sorry, we do not deliver to your area",
            "delivery_validator_not_eligible_content": "You are more then welcome to continue browsing our store",
            "delivery_validator_not_eligible_button_label": "Continue shopping",
            "delivery_validator_error_heading": "An error occured",
            "delivery_validator_error_content": "Sorry, it looks like we have encountered an unexpected error. Please try again.",
            "delivery_validator_error_button_label": "Continue shopping",
            "delivery_note_label": "Please enter delivery instructions (optional)",
            "delivery_note_label_required": "Please enter delivery instructions (required)",
            "delivery_note_error": "Please enter delivery instructions"
          },
          "shipping": {
            "heading": "Shipping",
            "note": "Please click the checkout button to continue.",
            "checkout_button": "Checkout",
            "datepicker_placeholder": "Choose a date.",
            "checkout_error": "Please choose a date for shipping.",
            "min_order_total": "Minimum order value for shipping is $0.00",
            "min_order_weight": "Minimum order weight for shipping is {{ weight }}",
            "max_order_total": "Maximum order value for shipping is $0.00",
            "max_order_weight": "Maximum order weight for shipping is {{ weight }}",
            "cart_eligibility_error": "Sorry, shipping is not available for your selected items."
          },
          "widget": {
            "zapiet_id_error": "There was a problem adding the Zapiet ID to your cart",
            "attributes_error": "There was a problem adding the attributes to your cart",
            "no_checkout_method_error": "Please select a delivery option"
          },
          "shipping_language_code": "en",
          "delivery_language_code": "en-US",
          "pickup_language_code": "en-GB"
        },
        "default_language": "en",
        "region": "us-2",
        "api_region": "api-us",
        "enable_zapiet_id_all_items": false,
        "draft_orders_enabled": false,
        "preselect_checkout_method": true,
        "widget_show_could_not_locate_div_error": true,
        "google_maps_api_key": "AIzaSyCG7oQpOmT3g1ERwTfMtJmHQIh5VETijlA"
      },
      "shop_identifier": "artcaffe-market.myshopify.com",
      "language_code": "en",
      "checkout_url": "/cart",
      "products": [{
        "variant_id": 46764228084029,
        "variant_title": "1 Slice",
        "product_id": 8691873743165,
        "collections": ["All", "Artisanal Breads", "Bakery"],
        "tags": ["artisanal breads", "bakery"],
        "type": "",
        "vendor": "artcaffe-market"
      }],
      "translations": {
        "en": {
          "methods": {
            "shipping": "Shipping",
            "pickup": "Pickups",
            "delivery": "Delivery"
          },
          "calendar": {
            "january": "January",
            "february": "February",
            "march": "March",
            "april": "April",
            "may": "May",
            "june": "June",
            "july": "July",
            "august": "August",
            "september": "September",
            "october": "October",
            "november": "November",
            "december": "December",
            "sunday": "Sun",
            "monday": "Mon",
            "tuesday": "Tue",
            "wednesday": "Wed",
            "thursday": "Thu",
            "friday": "Fri",
            "saturday": "Sat",
            "today": "",
            "close": "",
            "labelMonthNext": "Next month",
            "labelMonthPrev": "Previous month",
            "labelMonthSelect": "Select a month",
            "labelYearSelect": "Select a year",
            "and": "and",
            "between": "between"
          },
          "pickup": {
            "heading": "Store Pickup",
            "note": "",
            "location_placeholder": "Enter your postal code ...",
            "filter_by_region_placeholder": "Filter by state/province",
            "location_label": "Choose a location.",
            "datepicker_label": "Choose a date and time.",
            "date_time_output": "{{DATE}} at {{TIME}}",
            "datepicker_placeholder": "Choose a date and time.",
            "locations_found": "Please select a pickup location:",
            "no_locations_found": "Sorry, pickup is not available for your selected items.",
            "no_locations_region": "Sorry, pickup is not available in your region.",
            "no_date_time_selected": "Please select a date & time.",
            "checkout_button": "Checkout",
            "could_not_find_location": "Sorry, we could not find your location.",
            "checkout_error": "Please select a date and time for pickup.",
            "location_error": "Please select a pickup location.",
            "more_information": "More information",
            "opening_hours": "Opening hours",
            "dates_not_available": "Sorry, your selected items are not currently available for pickup.",
            "min_order_total": "Minimum order value for pickup is $0.00",
            "min_order_weight": "Minimum order weight for pickup is {{ weight }}",
            "max_order_total": "Maximum order value for pickup is $0.00",
            "max_order_weight": "Maximum order weight for pickup is {{ weight }}",
            "cart_eligibility_error": "Sorry, pickup is not available for your selected items."
          },
          "delivery": {
            "heading": "Local Delivery",
            "note": "Enter your postal code to check if you are eligible for local delivery:",
            "location_placeholder": "Enter your postal code ...",
            "datepicker_label": "Choose a date and time.",
            "datepicker_placeholder": "Choose a date and time.",
            "date_time_output": "{{DATE}} between {{SLOT_START_TIME}} and {{SLOT_END_TIME}}",
            "available": "Great! You are eligible for delivery.",
            "not_available": "Sorry, delivery is not available in your area.",
            "no_date_time_selected": "Please select a date & time for delivery.",
            "checkout_button": "Checkout",
            "could_not_find_location": "Sorry, we could not find your location.",
            "checkout_error": "Please enter a valid zipcode and select your preferred date and time for delivery.",
            "cart_eligibility_error": "Sorry, delivery is not available for your selected items.",
            "dates_not_available": "Sorry, your selected items are not currently available for delivery.",
            "min_order_total": "Minimum order value for delivery is {{ price }}",
            "min_order_weight": "Minimum order weight for delivery is 0.00kg",
            "max_order_total": "Maximum order value for delivery is {{ price }}",
            "max_order_weight": "Maximum order weight for delivery is 0.00kg",
            "delivery_validator_prelude": "Do we deliver?",
            "delivery_validator_placeholder": "Enter your postal code ...",
            "delivery_validator_button_label": "Go",
            "delivery_validator_eligible_heading": "Great, we deliver to your area!",
            "delivery_validator_eligible_content": "To start shopping just click the button below",
            "delivery_validator_eligible_button_label": "Continue shopping",
            "delivery_validator_not_eligible_heading": "Sorry, we do not deliver to your area",
            "delivery_validator_not_eligible_content": "You are more then welcome to continue browsing our store",
            "delivery_validator_not_eligible_button_label": "Continue shopping",
            "delivery_validator_error_heading": "An error occured",
            "delivery_validator_error_content": "Sorry, it looks like we have encountered an unexpected error. Please try again.",
            "delivery_validator_error_button_label": "Continue shopping",
            "delivery_note_label": "Please enter delivery instructions (optional)",
            "delivery_note_label_required": "Please enter delivery instructions (required)",
            "delivery_note_error": "Please enter delivery instructions"
          },
          "shipping": {
            "heading": "Shipping",
            "note": "Please click the checkout button to continue.",
            "checkout_button": "Checkout",
            "datepicker_placeholder": "Choose a date.",
            "checkout_error": "Please choose a date for shipping.",
            "min_order_total": "Minimum order value for shipping is $0.00",
            "min_order_weight": "Minimum order weight for shipping is {{ weight }}",
            "max_order_total": "Maximum order value for shipping is $0.00",
            "max_order_weight": "Maximum order weight for shipping is {{ weight }}",
            "cart_eligibility_error": "Sorry, shipping is not available for your selected items."
          },
          "widget": {
            "zapiet_id_error": "There was a problem adding the Zapiet ID to your cart",
            "attributes_error": "There was a problem adding the attributes to your cart",
            "no_checkout_method_error": "Please select a delivery option"
          },
          "shipping_language_code": "en",
          "delivery_language_code": "en-US",
          "pickup_language_code": "en-GB"
        }
      },
      "customer": {
        "first_name": "",
        "last_name": "",
        "company": "",
        "address1": "",
        "address2": "",
        "city": "",
        "province": "",
        "country": "",
        "zip": "",
        "phone": "",
        "tags": null
      }
    };
  }
});
})();

/******/ })()
;